import { AbstractControl } from '@angular/forms';

export type CustomForm = { form: AbstractControl; order: number; name: string };
